module.exports = __webpack_public_path__ + "static/img/bgimg3-2.effc705b.png";